/**
 * 订单详情抽屉模块 - 通用信息行组件
 *
 * 图标 + 标签 + 值（可选链接、可选行尾动作）的信息展示行，供活动信息、
 * 时间安排、付款记录等多个 Section 复用。
 */
import type { ReactNode } from 'react';

export default function InfoRow({ icon, label, value, href, trailing }: { icon: string; label: string; value: string; href?: string; trailing?: ReactNode }) {
  return (
    <div className="flex items-start gap-2.5 py-2 border-b border-gray-50 last:border-0">
      <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
        <i className={`${icon} text-sm text-gray-400`} />
      </div>
      <span className="text-xs text-gray-400 w-16 shrink-0 pt-0.5">{label}</span>
      {href ? (
        <a href={href} target={href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer"
          className="text-sm text-teal-500 hover:text-teal-600 hover:underline flex-1 leading-relaxed cursor-pointer transition-colors">{value}</a>
      ) : (
        <span className="text-sm text-gray-700 flex-1 leading-relaxed">{value}</span>
      )}
      {trailing && <div className="shrink-0 pt-0.5">{trailing}</div>}
    </div>
  );
}